// src/pages/TermsOfService/TermsOfService.js
import React from 'react';
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";

const TermsOfService = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Terms of Service Page",
  });

  return (
    <>
      <Helmet>
        <title>ضوابط الإستخدام - محصول</title>
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool, Terms of Service" />
        <meta property="og:title" content="ضوابط الإستخدام - محصول" />
        <meta property="og:description" content="Terms of Service of Mahsool platform." />
        <meta property="og:locale" content="ar_AR" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div
        className="w-screen px-20 flex items-center flex-col mt-10 font-semibold text-lg"
        dir="rtl"
      >
        <div className="h-20" />
        <span className="text-2xl mb-5">ضوابط الإستخدام لمنصة محصول</span>
        <div className="space-y-4">
          <h2 className="text-xl">1. مقدمة</h2>
          <p>
            مرحبًا بكم في منصة محصول. باستخدامكم لهذه المنصة، فإنكم توافقون على الالتزام بشروط الاستخدام التالية. إذا كنتم لا توافقون على أي من هذه الشروط، يرجى عدم استخدام المنصة.
          </p>
          <h2 className="text-xl">2. استخدام المنصة</h2>
          <p>
            يُسمح لكم باستخدام المنصة للأغراض القانونية فقط. لا يجوز لكم استخدام المنصة لأي غرض غير قانوني أو ضار أو ينتهك حقوق الآخرين. المستخدمون يمكن أن يكونوا مزارعين، تجار، مزودي خدمات، أو أعضاء في تعاونيات.
          </p>
          <h2 className="text-xl">3. حقوق الملكية الفكرية</h2>
          <p>
            جميع المحتويات الموجودة على المنصة، بما في ذلك النصوص والصور والفيديوهات والشعارات، محمية بموجب حقوق الملكية الفكرية وتعود ملكيتها لشركة ACTS أو لمزودي المحتوى المعنيين.
          </p>
          <h2 className="text-xl">4. المحتوى المقدم من المستخدم</h2>
          <p>
            أنتم مسؤولون عن جميع المحتويات التي تقومون بتحميلها أو نشرها على المنصة. يجب ألا يتضمن المحتوى المقدم منكم أي مواد غير قانونية أو تشهيرية أو مسيئة.
          </p>
          <h2 className="text-xl">5. تحديد المسؤولية</h2>
          <p>
            لا تتحمل شركة ACTS أو أي من مديريها أو موظفيها أو شركائها أي مسؤولية عن أي أضرار مباشرة أو غير مباشرة تنتج عن استخدام المنصة.
          </p>
          <h2 className="text-xl">6. التعديلات على الشروط</h2>
          <p>
            نحتفظ بالحق في تعديل هذه الشروط في أي وقت. سيتم إشعاركم بأي تغييرات هامة من خلال البريد الإلكتروني أو من خلال إشعار على المنصة.
          </p>
          <h2 className="text-xl">7. الاتصال بنا</h2>
          <p>
            إذا كان لديكم أي استفسارات أو مخاوف بشأن ضوابط الاستخدام هذه، يرجى الاتصال بنا عبر:
          </p>
          <ul className="list-disc pl-5">
            <li>البريد الإلكتروني: [ help@mahsool.sd]</li>
            <li>
              <div className="flex">
                <div>
                او مباشرة عبر:
                </div>
                <a
                  href="https://www.facebook.com/profile.php?id=100089265053519&mibwxtid=ZbWKwL"
                  target="_blank"
                  className="hover:scale-110 transition-all mx-2"
                >
                  <img
                    src="https://i.ibb.co/3fmF4zH/icons8-facebook-48.png"
                    alt=""
                    className="w-9"
                  />
                </a>
                
                <a
                  href="https://wa.me/message/K5BD6QOI2BBYE1"
                  target="_blank"
                  className="hover:scale-110 transition-all mx-2"
                >
                  <img
                    src="https://i.ibb.co/k2rf8LM/icons8-whatsapp-48-1.png"
                    alt=""
                    className="w-9"
                  />
                </a>
              </div>
            </li>
            
          </ul>
          <p>
            نشكركم على ثقتكم في منصة محصول، ونحن ملتزمون بتوفير تجربة استخدام آمنة وممتعة.
          </p>
        </div>
      </div>
    </>
  );
}

export default TermsOfService;
